export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevron-right-black.1c36ac5d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};